module.exports = __webpack_public_path__ + "static/bbtn-intro-video-c7c7d4fdcd2abd6fc4c55ee5742e7006.mp4";